import type { ReactNode } from "react";

/**
 * Application footer — `role="contentinfo"`, one per page. New in the rewrite; the legacy UI has none.
 *
 * Carries the app version and the CLIENT name (owner decision, 2026-07-31). Layout is intentionally open so a
 * designed footer can fill it. `legal` and `support` exist but render nothing until the Impressum/Datenschutz
 * question is answered — deliberately not invented.
 */
export function AppFooter({
  clientName,
  version,
  legal,
  support,
}: {
  /** The CLIENT/organization name (e.g. "Takeda") — NOT the white-label product name. */
  clientName: string;
  /** Build identity, injected at build time. First question on any support ticket. */
  version: string;
  legal?: ReactNode;
  support?: ReactNode;
}) {
  return (
    <footer className="border-border text-muted-foreground flex flex-wrap items-center justify-between gap-2 border-t px-4 py-3 text-xs">
      <span>{clientName}</span>
      <span className="font-mono" data-testid="app-version">
        {version}
      </span>
      {legal ?? null}
      {support ?? null}
    </footer>
  );
}
